<template>
  <template-item
    :model="$notification"
    object-key-for-title="title"
    title-prepend="Push уведомление / "
    :show-delete="false"
    :show-actions="false"
  >
    <template v-slot:topDividerActions>
      <v-row
        no-gutters
        style="gap: 10px"
      >
        <v-btn
          v-if="!$notification.item?.id"
          depressed
          color="primary"
          :disabled="!formValid"
          @click="sendNow"
        >
          <div class="text-none">Отправить</div>
        </v-btn>
        <v-btn
          v-if="!$notification.item?.id"
          depressed
          color="primary"
          :disabled="!formValid"
          @click="openSendLaterModal()"
        >
          <div class="text-none">Отправить позже</div>
        </v-btn>
        <v-btn
          v-if="
            !$notification.item?.processed_at &&
            $notification.item.id &&
            $notification.item.status !== notificationStatusEnum.GENERATING_RECIPIENTS
          "
          depressed
          color="primary"
          :disabled="!formValid"
          @click="save()"
        >
          <div class="text-none">Сохранить</div>
        </v-btn>
        <v-btn
          v-if="canChangeSendDate && $notification.item?.id"
          depressed
          color="primary"
          @click="openSendLaterModal()"
        >
          <div class="text-none">Изменить время отправки</div>
        </v-btn>
        <v-btn
          v-if="
            !$notification.item?.processed_at &&
            $notification.item.status !== notificationStatusEnum.GENERATING_RECIPIENTS
          "
          depressed
          color="primary"
          :disabled="!formValid"
          @click="openSendGroupModal()"
        >
          <div class="text-none">Отправить группе</div>
        </v-btn>
        <SendLaterModal
          v-model="sendLaterModalModelValue"
          :item="$notification.item"
          @accept="sendLater"
        />
        <SendGroupModal
          v-model="sendGroupModalModelValue"
          :max-group-size="maxGroupSize"
          @accept="sendToGroup"
        />
      </v-row>
    </template>
    <template
      v-if="ready"
      v-slot:default="{ object }"
    >
      <v-row no-gutters>
        <v-col
          class="pa-0"
          cols="7"
        >
          <DetailData
            ref="detailDataRef"
            :item="object"
          />
          <FiltersData
            :item="object"
            @refreshForecast="refreshForecast"
          />
        </v-col>

        <v-col class="ml-8">
          <PushPreviewIos :item="object" />
          <PushForecast
            v-if="object.status === notificationStatusEnum.CREATED"
            :forecast="forecastData"
            :loading="forecastLoading"
            @refreshForecast="refreshForecast(true)"
          />
          <PushAnalytics
            :analytics="analyticsData"
            :loading="analyticsLoading"
            @refreshAnalytics="refreshAnalytics"
            v-else
          />
        </v-col>
      </v-row>
    </template>
  </template-item>
</template>

<script>
  import SendGroupModal from './sendModals/SendGroupModal.vue'
  import PushPreviewIos from './PushPreviewIos.vue'
  import PushAnalytics from './PushAnalytics.vue'
  import PushForecast from './PushForecast.vue'
  import DetailData from '@/admin/views/notifications/notificationPage/DetailData.vue'
  import FiltersData from '@/admin/views/notifications/notificationPage/FiltersData.vue'
  import { notificationStatusEnum } from '@/airModels/types/notificationModel'
  import { mapState } from 'vuex'
  import SendLaterModal from './sendModals/SendLaterModal.vue'
  import cloneDeep from 'lodash/cloneDeep'
  import debounce from 'lodash/debounce'
  import isEqual from 'lodash/isEqual'
  import moment from 'moment'

  export default {
    name: 'NotificationPage',
    components: {
      FiltersData,
      DetailData,
      PushForecast,
      PushAnalytics,
      PushPreviewIos,
      SendLaterModal,
      SendGroupModal
    },
    data: () => ({
      ready: false,
      sendLaterModalModelValue: false,
      sendGroupModalModelValue: false,
      forecastData: {
        total_users: 0,
        total_filtered_users: 0,
        total_pushes: 0
      },
      maxGroupSize: 0,
      forecastLoading: false,
      analyticsLoading: false,
      lastForecastRequestId: 0,
      lastParticipantFilters: null
    }),
    computed: {
      notificationStatusEnum() {
        return notificationStatusEnum
      },
      formValid: mapState({
        form: state => state.form
      }).form,
      analyticsData() {
        const defaultAnalytics = {
          total_pushes: 0,
          completed_pushes: 0,
          read_from_push: 0,
          read_in_feed: 0,
          total_read: 0,
          users_who_received_push: 0,
          total_delivered_pushes: 0
        }
        return this.$notification.item?.analytics || defaultAnalytics
      },
      canChangeSendDate() {
        const item = this.$notification.item
        if (!item) return false

        return (
          (item.send_date &&
            !item.processed_at &&
            moment.utc(item.send_date, 'YYYY-MM-DD HH:mm:ss').local().isAfter(moment())) ||
          !item.id
        )
      }
    },
    methods: {
      init() {
        console.log('init')
        const id = this.$route.params.notificationId
        if (id === 'new') {
          this.$notification.item = cloneDeep(this.$notification.default)
          this.ready = true
        } else {
          this.$notification.loadItem(this.$route.params.notificationId).then(v => {
            if (v.subject_type && typeof v.subject_type === 'object')
              v.subject_type = v.subject_type.id
            this.ready = true
          })
        }
      },
      isObject(item) {
        return item && typeof item === 'object'
      },
      makeUpdate() {
        this.$notification.item.participant_filters = this.$notification.getParticipantFilters(
          this.$notification.item.participant_filters
        )

        var currentItem = cloneDeep(this.$notification.item)

        if (this.isObject(currentItem.subject_type)) {
          currentItem.subject_type = currentItem.subject_type.id
        }

        if (this.isObject(currentItem.notification_type)) {
          currentItem.notification_type = currentItem.notification_type.id
        }

        return this.$notification.update(currentItem)
      },
      save() {
        this.makeUpdate()
          .then(v => {
            this.$notification.item = v
            this.$store.commit('setSnackbar', {
              color: 'success',
              text: 'Успех'
            })
          })
          .catch(() => {
            this.$store.commit('setSnackbar', {
              color: 'error',
              text: 'Ошибка'
            })
          })
      },
      sendNow() {
        this.$notification.item.participant_filters = this.$notification.getParticipantFilters(
          this.$notification.item.participant_filters
        )
        this.$notification
          .create({ ...this.$notification.item, should_send: false })
          .then(res => {
            this.$notification.item = res
            return this.$refs.detailDataRef.afterSave()
          })
          .then(_ => this.$notification.sendPostSingle('send_one', this.$notification.item.id))
          .then(res => {
            const item = this.$notification.item
            this.$router.replace({
              name: 'notificationItem',
              params: { notificationId: item.id }
            })
            this.$store.commit('setSnackbar', {
              color: 'success',
              text: 'Успех'
            })
          })
          .catch(error => {
            console.log(error)
            this.$store.commit('setSnackbar', {
              color: 'error',
              text: 'Ошибка'
            })
          })
      },
      sendLater(date) {
        this.$notification.item.send_date = date
        if (!this.$notification.item?.id) {
          this.sendNow()
        } else {
          this.save()
        }
      },
      openSendLaterModal() {
        this.sendLaterModalModelValue = true
      },
      async openSendGroupModal() {
        const item = this.$notification.item
        if (!item?.id) {
          this.maxGroupSize = this.forecastData.total_pushes
        } else {
          const res = await this.$notification.sendGetSingle('available_batch_size', item.id)
          this.maxGroupSize = res.result.count
        }
        this.sendGroupModalModelValue = true
      },
      refreshAnalytics() {
        this.analyticsLoading = true
        this.$notification
          .loadItem(this.$route.params.notificationId)
          .then(v => {})
          .finally(() => {
            this.analyticsLoading = false
          })
      },
      debouncedRefreshForecast: debounce(function () {
        this.refreshForecast()
      }, 500),

      refreshForecast(force = false) {
        const currentFilters = this.$notification.getParticipantFilters(
          this.$notification.item.participant_filters
        )

        // Проверяем, изменились ли фильтры
        if (!force && isEqual(currentFilters, this.lastParticipantFilters)) {
          return
        }

        this.forecastLoading = true
        const requestId = ++this.lastForecastRequestId

        this.$analytics
          .sendPostSingle('pushes_by_filters', undefined, currentFilters)
          .then(v => {
            // Проверяем, что это последний запрос
            if (requestId === this.lastForecastRequestId) {
              this.forecastData = v
              this.lastParticipantFilters = cloneDeep(currentFilters)
            }
          })
          .catch(() => {
            if (requestId === this.lastForecastRequestId) {
              this.$store.commit('setSnackbar', {
                color: 'error',
                text: 'Ошибка'
              })
            }
          })
          .finally(() => {
            if (requestId === this.lastForecastRequestId) {
              this.forecastLoading = false
            }
          })
      },
      sendToGroup(groupSize) {
        const item = this.$notification.item
        if (!item) return
        item.send_batch_size = groupSize
        if (!item.id) this.sendNow()
        else {
          this.$notification
            .sendPostSingle('send_in_batch', item.id, { batch_size: groupSize })
            .then(() => {
              setTimeout(() => {
                this.refreshAnalytics()
              }, 1000)
            })
          this.send_in_batch = groupSize
        }
      }
    },
    watch: {
      '$notification.item.participant_filters': {
        handler() {
          if (
            this.$notification.item?.status === this.notificationStatusEnum.CREATED &&
            this.ready
          ) {
            this.debouncedRefreshForecast()
          }
        },
        deep: true
      }
    },
    mounted() {
      this.init()
    }
  }
</script>

<style scoped></style>
